import React from 'react';
import { CircularProgress } from '@material-ui/core';
import './styles.css';

export function Loader(props) {
    const { isLoading } = props;
    return (
        <>
            {
                isLoading ?
                    (<div className="loader_custom_component" >
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress size={60} color='#fff' />
                        </div>
                    </div>) :
                    (<div></div>)
            }
        </>
    )
}